import React from 'react';
import {
    Box,
    Button,
    Card, CardContent,
    CardHeader,
    Divider,
    TextField
} from '@material-ui/core';
import { useApi } from '../../components/api';

export const AcceptInviteForm = ({ className, ...rest }: any) => {

    const isLoading = false;

    const { api } = useApi('invites/');

    const handleSubmit = async (ev: any) => {
        ev.preventDefault();
        const { convite } = ev.currentTarget.elements;

        const conviteId = convite.value;

        try {
            await api.post<{ tenantId?: string; }>('accept/' + conviteId, {});
            // alert('ok relogue');
            window.location.reload(); 
        } catch (error) {
            //alert(error);
            if (error.response) {
              alert(error.response.data);
            }
            
        }

    };

    return (
        <form
            noValidate
            onSubmit={handleSubmit}
        >
            <Card>
                <CardHeader
                    subheader="Utilize aqui o código para se associar a um posto"
                    title="Possui um código de convite?" />
                <Divider />
                <CardContent>

                    <TextField
                        fullWidth
                        label="Convite"
                        margin="normal"
                        name="convite"
                        type="text"
                        variant="outlined" />

                </CardContent>
                <Divider />
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    p={2}
                >
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                    >
                        Utilizar código de convite
                    </Button>

                </Box>

            </Card>
        </form>
    );
};


